"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextStyles = function (props, theme) {
    var as = props.as, className = props.className, block = props.block, nowrap = props.nowrap, variant = props.variant;
    var fonts = theme.fonts;
    var variantObject = fonts[variant || 'medium'];
    return {
        root: [
            theme.fonts.medium,
            {
                display: block ? (as === 'td' ? 'table-cell' : 'block') : 'inline',
                fontFamily: (variantObject && variantObject.fontFamily) || 'inherit',
                fontSize: (variantObject && variantObject.fontSize) || 'inherit',
                fontWeight: (variantObject && variantObject.fontWeight) || 'inherit',
                color: (variantObject && variantObject.color) || 'inherit',
                mozOsxFontSmoothing: variantObject && variantObject.MozOsxFontSmoothing,
                webkitFontSmoothing: variantObject && variantObject.WebkitFontSmoothing
            },
            nowrap && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            className
        ]
    };
};
//# sourceMappingURL=Text.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Text/Text.styles.js
// module id = 1223
// module chunks = 0